import DrawerAccordion from '@components/DrawerAccordion';
import { isTemplatePlaceholder } from '@/types';
import EngagementForm from '@pages/QuickFilterListCreatorPage/criteriaComponents/EngagementForm';
import { EventAttendance } from '@pages/QuickFilterListCreatorPage/criteriaComponents/EventAttendance';
import MailingsForm from '@pages/QuickFilterListCreatorPage/criteriaComponents/MailingsForm';
import Roster from '@pages/QuickFilterListCreatorPage/criteriaComponents/Roster';
import { FilterPanelPartBProps } from './types';

export default function FilterPanelPartB({
  filterCriteria,
  dispatchFilterCriteria,
  accordionStates,
  setAccordionStates,
  disabled,
  setIsEventDateFilterInvalid,
  setIsActivityDateFilterInvalid,
}: FilterPanelPartBProps) {
  return (
    <>
      <DrawerAccordion
        inUse={(filterCriteria.activities?.length ?? 0) > 0}
        headerText="Engagement history"
        expanded={accordionStates.engagement}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, engagement: ex })}
        disabled={disabled}
      >
        <EngagementForm
          activityValue={filterCriteria.activities ?? []}
          onActivityChange={(payload) =>
            dispatchFilterCriteria({
              type: 'setActivities',
              payload: isTemplatePlaceholder(payload) ? [] : payload,
            })
          }
          activityStatus={filterCriteria.activityStatuses ?? []}
          onActivityStatusChange={(payload) =>
            dispatchFilterCriteria({
              type: 'setActivityStatuses',
              payload: isTemplatePlaceholder(payload) ? [] : payload,
            })
          }
          setIsFilterInvalid={setIsActivityDateFilterInvalid}
          activityDateValue={filterCriteria.activityDateRange}
          onActivityDateChange={(payload) =>
            dispatchFilterCriteria({
              type: 'setActivityDateRange',
              payload: {
                ...payload,
                periodDetails: isTemplatePlaceholder(payload.periodDetails)
                  ? 'lastyear'
                  : payload.periodDetails,
                displayedStartDate: isTemplatePlaceholder(payload.displayedStartDate)
                  ? null
                  : payload.displayedStartDate,
                displayedEndDate: isTemplatePlaceholder(payload.displayedEndDate)
                  ? null
                  : payload.displayedEndDate,
              },
            })
          }
          subject={filterCriteria.subject ?? ''}
          onSubjectChange={(payload) =>
            dispatchFilterCriteria({
              type: 'setSubject',
              payload: isTemplatePlaceholder(payload) ? '' : payload,
            })
          }
        />
      </DrawerAccordion>
      <DrawerAccordion
        inUse={filterCriteria.mailings.length > 0}
        headerText="Mailing"
        expanded={accordionStates.mailing}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, mailing: ex })}
        disabled={disabled}
      >
        <MailingsForm
          mailingValue={filterCriteria.mailings}
          onChangeMailing={(payload) => dispatchFilterCriteria({ type: 'setMailings', payload })}
          mailingStatus={filterCriteria.mailingstatus ?? 'delivered'}
          onChangeMailingStatus={(e) =>
            dispatchFilterCriteria({
              type: 'setMailingStatus',
              payload: e.target.value,
            })
          }
        />
      </DrawerAccordion>
      <DrawerAccordion
        inUse={Boolean(filterCriteria.election)}
        headerText="Roster"
        expanded={accordionStates.roster}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, roster: ex })}
        disabled={disabled}
      >
        <Roster
          electionValue={filterCriteria.election}
          electionOnChange={(payload) => {
            if (isTemplatePlaceholder(payload)) {
              dispatchFilterCriteria({ type: 'setElection', payload: null });
            } else {
              dispatchFilterCriteria({ type: 'setElection', payload });
            }
          }}
          electorateValue={filterCriteria.electorates}
          electorateOnChange={(payload) => {
            if (isTemplatePlaceholder(payload)) {
              dispatchFilterCriteria({ type: 'setElectorates', payload: [] });
            } else {
              dispatchFilterCriteria({ type: 'setElectorates', payload });
            }
          }}
          rosterTypeValue={filterCriteria.rostertypes}
          rosterTypeOnChange={(payload) => {
            if (isTemplatePlaceholder(payload)) {
              dispatchFilterCriteria({ type: 'setRosterTypes', payload: [] });
            } else {
              dispatchFilterCriteria({ type: 'setRosterTypes', payload });
            }
          }}
          rosterCriteriaValue={filterCriteria.rostercriteria}
          rosterCriteriaOnChange={(payload) =>
            dispatchFilterCriteria({ type: 'setRosterCriteria', payload })
          }
        />
      </DrawerAccordion>
      <DrawerAccordion
        inUse={
          filterCriteria.statuses.length > 0 ||
          filterCriteria.eventTypes.length > 0 ||
          Boolean(filterCriteria.eventDateRange.endDate) ||
          Boolean(filterCriteria.eventDateRange.startDate) ||
          filterCriteria.events.length > 0 ||
          filterCriteria.eventCampaigns.length > 0
        }
        headerText="Event attendance"
        expanded={accordionStates.events}
        onChange={(_evt, ex) => setAccordionStates({ ...accordionStates, events: ex })}
        disabled={disabled}
      >
        <EventAttendance
          eventStatuses={filterCriteria.statuses}
          onChangeEventStatuses={(payload) =>
            dispatchFilterCriteria({
              type: 'setStatuses',
              payload: isTemplatePlaceholder(payload) ? [] : payload,
            })
          }
          eventTypes={filterCriteria.eventTypes}
          onChangeEventTypes={(payload) =>
            dispatchFilterCriteria({
              type: 'setEventTypes',
              payload: isTemplatePlaceholder(payload) ? [] : payload,
            })
          }
          eventDateRange={filterCriteria.eventDateRange}
          events={filterCriteria.events}
          onChangeEvents={(payload) =>
            dispatchFilterCriteria({
              type: 'setEvents',
              payload: isTemplatePlaceholder(payload) ? [] : payload,
            })
          }
          setIsEventDateFilterInvalid={setIsEventDateFilterInvalid}
          onChangeEventDateRange={(payload) =>
            dispatchFilterCriteria({ type: 'setEventDateRange', payload })
          }
          campaigns={filterCriteria.eventCampaigns}
          onChangeCampaigns={(payload) =>
            dispatchFilterCriteria({
              type: 'setEventCampaigns',
              payload: isTemplatePlaceholder(payload) ? [] : payload,
            })
          }
        />
      </DrawerAccordion>
    </>
  );
}
